/* QSPEC Calm — WORK / PLAY split slider (before/after style)
 * Two stacked images; the top one is clipped at --calm-split (0..1).
 * Drag with pointer, keyboard on the handle, auto sweep once when it enters the viewport.
 */
(function () {
  'use strict';
  function init(el) {
    var handle = el.querySelector('[data-split-handle]');
    var pos = parseFloat(el.getAttribute('data-split-start') || '0.5');
    var dragging = false, swept = false, raf = null, io = null, destroyed = false;
    function set(p) {
      pos = Math.min(1, Math.max(0, p));
      el.style.setProperty('--calm-split', pos.toFixed(4));
      if (handle) handle.setAttribute('aria-valuenow', Math.round(pos * 100));
    }
    function fromEvent(e) {
      var r = el.getBoundingClientRect();
      set((e.clientX - r.left) / r.width);
    }
    function cancelSweep() { swept = true; if (raf) { cancelAnimationFrame(raf); raf = null; } }
    function down(e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true; cancelSweep();
      el.classList.add('is-dragging');
      if (el.setPointerCapture && e.pointerId != null) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
      fromEvent(e);
    }
    function move(e) { if (!dragging) return; fromEvent(e); e.preventDefault(); } // only while dragging, so vertical page scroll stays free
    function up() { dragging = false; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerdown', down);
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    function onKey(e) {
      var step = e.shiftKey ? 0.01 : 0.05, k = e.key;
      if (k === 'ArrowLeft' || k === 'ArrowDown') { cancelSweep(); set(pos - step); e.preventDefault(); }
      else if (k === 'ArrowRight' || k === 'ArrowUp') { cancelSweep(); set(pos + step); e.preventDefault(); }
      else if (k === 'Home') { cancelSweep(); set(0); e.preventDefault(); }
      else if (k === 'End') { cancelSweep(); set(1); e.preventDefault(); }
      else if (k === 'PageDown') { cancelSweep(); set(pos - 0.2); e.preventDefault(); }
      else if (k === 'PageUp') { cancelSweep(); set(pos + 0.2); e.preventDefault(); }
    }
    if (handle) handle.addEventListener('keydown', onKey);
    set(pos);
    // one automatic sweep on first view so people notice it moves
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || swept) return;
        swept = true; io.disconnect(); io = null;
        var start = performance.now(), from = pos, dur = 1600;
        (function tick(t) {
          if (destroyed || dragging || raf === false) return;
          var k = Math.min(1, (t - start) / dur);
          var e = 0.5 - 0.5 * Math.cos(k * Math.PI); // ease in-out
          set(k < 0.5 ? from + (0.22 - from) * (e * 2) : 0.22 + (0.5 - 0.22) * ((e - 0.5) * 2));
          if (k < 1) raf = requestAnimationFrame(tick); else raf = null;
        })(start);
      }, { threshold: 0.6 });
      io.observe(el);
    }
    el._calmSplit = { destroy: function () {
      if (destroyed) return;
      destroyed = true; cancelSweep();
      el.removeEventListener('pointerdown', down);
      el.removeEventListener('pointermove', move);
      el.removeEventListener('pointerup', up);
      el.removeEventListener('pointercancel', up);
      if (handle) handle.removeEventListener('keydown', onKey);
      if (io) { io.disconnect(); io = null; }
      el._init = false; delete el._calmSplit;
    } };
  }
  function boot() { document.querySelectorAll('[data-calm-split]').forEach(function (el) { if (!el._init) { el._init = true; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (!window.__calmSplitBound) {
    window.__calmSplitBound = true;
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function (e) {
      var t = e.target, els = t && t.querySelectorAll ? t.querySelectorAll('[data-calm-split]') : [];
      if (t && t.matches && t.matches('[data-calm-split]') && t._calmSplit) t._calmSplit.destroy();
      els.forEach(function (el) { if (el._calmSplit) el._calmSplit.destroy(); });
    });
  }
})();
